export default "__VITE_ASSET__Bx7yeTJQ__"